{
  "name": "id-app",
  "version": "1.2.2-develop.0",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "start": "cp ./package.json ./src/assets && ng serve --ssl --host localhost.sparbanken.me",
    "watch": "ng test",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "style-lint": "stylelint  src/**/*.scss --fix",
    "test": "ng test --watch=false --coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/platform-browser-dynamic": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@angular/service-worker": "^22.2.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.2",
    "@angular/cdk": "^22.2.1",
    "@angular/cli": "^22.2.2",
    "@angular/compiler-cli": "^22.2.1",
    "@angular/material": "^22.2.1",
    "@eslint/js": "^10.0.1",
    "@sparbanken-syd/auth-backend": "^2.6.5",
    "@sparbanken-syd/id-be": "^1.0.0",
    "@sparbanken-syd/personnummer": "^3.1.0",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.2",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.0.2",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@types/hammerjs": "^2.0.46",
    "@types/node": "^24",
    "@vitest/coverage-v8": "^5.0.0",
    "angular-eslint": "^22.1.0",
    "eslint": "^10.9.0",
    "hammerjs": "^2.0.8",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "^5.10.0",
    "jsdom": "^30.0.1",
    "postcss": "^8.5.6",
    "qr-scanner": "^1.4.2",
    "stylelint": "^17.15.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.58.0",
    "vite": "^8.3.0",
    "vitest": "5"
  }
}
